import { IApplicationContext } from '../../../types/applicationContext';
import { ValidationError } from '@cian/peperrors';
import { fetchPublicOfferCheckBusinessEntity } from 'shared/repositories/dailyrent/v1/public-offer/check-business-entity/apiHelpers';
import { TPublicOfferCheckBusinessEntityResponse } from 'shared/repositories/dailyrent/v1/public-offer/check-business-entity/types';
import { IErrorResponseSchema } from 'shared/repositories/dailyrent/entities/schemas/ErrorResponseSchema';

export const errorCodes = [
  'invalidOkved',
  'hasNoValidatedBusinessEntity',
  'businessEntityByInnNotFound',
  'businessEntityOnSanctionsLists',
  'invalidUserType',
  'businessAlreadyAcceptedPublicOffer',
] as const;

const unknownValidationError = new ValidationError({
  message: 'Неизвестная ошибка',
  domain: '/v1/public-offer/check-business-entity/',
  details: { errorCode: 'unknown' },
});

const getValidationError = (response: IErrorResponseSchema) => {
  const { message, errors } = response;

  if (!errors) {
    return unknownValidationError;
  }

  const typedErrors = errors as Array<{ code: (typeof errorCodes)[number] }>;
  const errorCode = typedErrors[0].code;

  if (!errorCodes.includes(errorCode)) {
    return unknownValidationError;
  }

  return new ValidationError({
    message: message ?? 'Ошибка при проверке ИП',
    domain: '/v1/public-offer/check-business-entity/',
    details: { errorCode },
  });
};

export const checkBusinessEntity = async (context: IApplicationContext) => {
  const { logger, httpApi } = context;

  try {
    const { response, statusCode } = (await fetchPublicOfferCheckBusinessEntity({
      httpApi,
    })) as TPublicOfferCheckBusinessEntityResponse;

    if (statusCode !== 200) {
      throw getValidationError(response);
    }

    return response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
};
